import React from "react";
import { DefaultTheme, StyledComponent } from "styled-components";
import { useTheme } from "styled-components/native";
import { PropsOf } from "src/typeUtils";
import { TextProps, ThemedText } from "./Text.styled";
import { useMemo } from "react";
import { StyleSheet } from "react-native";
const BaseTextComponent: React.FC<PropsOf<typeof ThemedText> & TextProps> = ({
  variant = "regular",
  style,
  underlined,
  ...props
}) => {
  const theme = useTheme();
  const textTheme = theme.text;

  const baseTheme = useMemo(() => {
    const { variants, ...restOfTheme } = textTheme;
    return restOfTheme;
  }, [textTheme]);

  const finalStyle = useMemo(() => {
    if (underlined) {
      return StyleSheet.compose({ textDecorationLine: "underline" }, style);
    }
    return style;
  }, [style, underlined]);

  return (
    <ThemedText
      {...baseTheme}
      variant={variant}
      style={finalStyle}
      {...props}
      onPress={props.onPress || props.onClick}>
      {props.children}
    </ThemedText>
  );
};

export const Text = BaseTextComponent as StyledComponent<
  "span",
  DefaultTheme,
  PropsOf<typeof ThemedText> & TextProps,
  never
>;

export default Text as StyledComponent<
  "span",
  DefaultTheme,
  PropsOf<typeof ThemedText> & TextProps,
  never
>;

